import React from 'react';
import styles from './SpeechBubble.scss';

export interface ISpeechBubbleProps {
    className?: string;
    direction?: 'right' | 'bottom';
}

const SpeechBubble: React.FC<React.PropsWithChildren<ISpeechBubbleProps>> = ({ className = '', direction = 'right' }) => {
    return <div className={[styles.speechBubble, className, styles[direction]].filter((e) => e).join(' ')}></div>;
};

export default SpeechBubble;
